import React from 'react';
import { Star } from 'lucide-react';
import { getLawyerPartnerAppearance } from '../../utils/lawyerPartners';

export default function PartnerLawyerBadge({ partner, compact = false }) {
  if (!partner) return null;

  const appearance = getLawyerPartnerAppearance(partner.classificacao);
  const stars = Number(partner.rating || 0);
  const negotiatesHonorarios = Boolean(partner.negotiatesHonorarios);
  const blocksContact = appearance.contactBlocked === true;

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-lg border px-2.5 py-1.5 ${appearance.badge} ${compact ? 'text-xs' : 'text-sm'}`}
      title={
        blocksContact
          ? `${appearance.label} · ${partner.rating}/5 · contato bloqueado`
          : `${appearance.label} · ${partner.rating}/5`
      }
    >
      <span className="max-w-[180px] truncate font-semibold text-current">{partner.nome}</span>
      {blocksContact ? (
        <span
          className={`inline-flex items-center rounded-full border border-red-300/70 bg-red-50/80 px-2 py-0.5 text-[10px] font-semibold text-red-900 ${
            compact ? '' : 'uppercase tracking-wide'
          }`}
          title="Parceiro ruim: WhatsApp, e-mail e agente desabilitados"
        >
          Sem contato
        </span>
      ) : null}
      {negotiatesHonorarios ? (
        <span
          className={`inline-flex items-center rounded-full border border-emerald-300/60 bg-emerald-50/60 px-2 py-0.5 text-[10px] font-semibold text-emerald-900 ${
            compact ? '' : 'uppercase tracking-wide'
          }`}
          title="Negocia honorários"
        >
          {compact ? 'Honorários' : 'Negocia honorários'}
        </span>
      ) : null}
      <span className="inline-flex items-center gap-0.5 whitespace-nowrap text-current">
        {Array.from({ length: 5 }).map((_, index) => (
          <Star
            key={index}
            className={`h-3 w-3 text-current ${index < stars ? 'fill-current' : ''}`}
          />
        ))}
      </span>
      {!compact && (
        <span className="text-[11px] font-semibold uppercase tracking-wide text-current">
          {appearance.label}
        </span>
      )}
    </div>
  );
}
